var __jsx = React.createElement;
import React from "react";
import { Events } from "services/adobeAnalytics";
import { ELSButton } from "components/common/elsevier/Button/Button";
import Styles from "../Styles.module.scss";
function ExploreContactButtons() {
  return /*#__PURE__*/React.createElement("div", {
    className: Styles.exploreButtonsContainer
  }, /*#__PURE__*/React.createElement(ELSButton, {
    "data-cy": "sp-drawer-explore-dbs-button",
    className: "".concat(Styles.exploreButtonsContainer__exploreButton, " es-link__blue--16-font"),
    href: "https://www.elsevier.com/products/engineering-village/databases",
    onClick: function onClick() {
      Events.startPage.exploreDatabases();
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Explore databases"), /*#__PURE__*/React.createElement(ELSButton, {
    "data-cy": "sp-drawer-contact-us-button",
    className: "".concat(Styles.exploreButtonsContainer__contactButton, " es-button__tertiary"),
    variant: "outlined",
    href: "https://www.elsevier.com/products/engineering-village/contact-us",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Contact Us"));
}
export default ExploreContactButtons;